import {PayloadAction} from '@reduxjs/toolkit';

import {IColumnSortData} from 'components/@common/widgets/custom-table/table-column-menu';

import {ITableReportSliceState} from '../table-report-slice-types';

export const createTableReportSortReducer = <S extends ITableReportSliceState>() => ({
    setSortData(state: S, {payload}: PayloadAction<IColumnSortData>) {
        state.reportOptions.sort = payload.sort;
        state.reportOptions.noFetchWithSort = !!payload.noFetch;
    },
    resetSort(state: S, {payload}: PayloadAction<{noFetch: boolean}>) {
        state.reportOptions.sort = {};
        state.reportOptions.noFetchWithSort = !!payload.noFetch;
    },
});
